module.exports = __webpack_public_path__ + "img/nature-54.71e6bcec.jpg";